import type { ListData } from '@openx/types/inventoryList.ts';

export const filterAndMapItems = (listData: ListData[], id: string) => {
  return listData.reduce<{ filteredNames: string[]; filteredListData: ListData[] }>(
    (result, item) => {
      if (item.id !== id) {
        result.filteredNames.push(item.name);
        result.filteredListData.push(item);
      }
      return result;
    },
    { filteredNames: [], filteredListData: [] }
  );
};
